import { getCurrentTouch, getFirstTouch, getSessionId, buildSourceSummaryClient } from './leadTracking';

/**
 * Wrap API body with normalized `lead` + `lead_context` for /api/contact.
 */
export function buildLeadEnvelope(formType, partialLead, options = {}) {
  const { locale = '', estimateSnapshot = null } = options;
  const first = getFirstTouch();
  const current = getCurrentTouch();
  const sid = getSessionId();

  const host = typeof window !== 'undefined' ? window.location.host : '';
  const href = typeof window !== 'undefined' ? window.location.href : '';

  const lead = {
    ...partialLead,
    route_path: partialLead.route_path || (typeof window !== 'undefined' ? window.location.pathname : '/'),
    full_page_url: partialLead.full_page_url || href,
    site_host: partialLead.site_host || host,
    locale: partialLead.locale || locale,
    first_landing_path: partialLead.first_landing_path || first.landing_path || '',
    first_landing_url: partialLead.first_landing_url || first.landing_url || '',
    referrer: partialLead.referrer || current.referrer || '',
    referrer_domain: partialLead.referrer_domain || current.referrer_domain || '',
    utm_source: partialLead.utm_source || current.utm_source || first.utm_source || '',
    utm_medium: partialLead.utm_medium || current.utm_medium || first.utm_medium || '',
    utm_campaign: partialLead.utm_campaign || current.utm_campaign || first.utm_campaign || '',
    utm_content: partialLead.utm_content || current.utm_content || first.utm_content || '',
    utm_term: partialLead.utm_term || current.utm_term || first.utm_term || '',
    gclid: partialLead.gclid || current.gclid || first.gclid || '',
    fbclid: partialLead.fbclid || current.fbclid || first.fbclid || '',
    msclkid: partialLead.msclkid || current.msclkid || first.msclkid || '',
    ttclid: partialLead.ttclid || current.ttclid || first.ttclid || '',
    source_summary: partialLead.source_summary || buildSourceSummaryClient(first, current),
    session_id: partialLead.session_id || sid,
    user_agent_summary: partialLead.user_agent_summary || (typeof navigator !== 'undefined' ? navigator.userAgent.slice(0, 500) : ''),
  };

  const body = {
    formType,
    lead,
    lead_context: {
      session_id: sid,
      first_touch: first,
      current_touch: current,
    },
  };

  if (formType === 'configurator' && estimateSnapshot) {
    body.estimateSnapshot = estimateSnapshot;
  }

  return body;
}
